export default __webpack_public_path__ + "static/media/withdraw_icon.bf6e49e3.svg";